/**
 * Posts a save request message to the parent window
 * @param {Object} payload - The data to send to parent
 * @param {string} targetOrigin - The target origin (default: "*")
 * @param {Window} targetWindow - The target window (default: window.parent)
 */
export function postSaveToParent(payload, targetOrigin = "*", targetWindow = window.parent) {
    console.log('Posting save to parent:', payload);
    targetWindow.postMessage({ type: "SAVE_REQUEST", payload }, targetOrigin);
}

/**
 * Generates the save payload with pattern and product information
 * @param {Object} activePattern - The active pattern object
 * @param {Object} selectedSlotProducts - The selected products by slot
 * @returns {Object} The payload object
 */
export function generateSavePayload(activePattern, selectedSlotProducts) {
    if (!activePattern) {
        console.error('No active pattern available');
        return null;
    }

    const { origin } = window.location;
    const patternId = activePattern.id || activePattern.patternId || '';
    
    // Get selected product IDs
    const productIds = [];
    if (activePattern.descriptor) {
        const colorSlots = activePattern.descriptor.split(',').map(slot => slot.trim());
        colorSlots.forEach((slot, index) => {
            const product = selectedSlotProducts[index];
            if (product && product.id) {
                productIds.push(product.id);
            } else {
                productIds.push('-1');
            }
        });
    }
    
    const productSelection = productIds.join(',');
    const projectUrl = `${origin}/visualizer/pattern/${patternId}/products/${productSelection}`;
    
    return {
        activePatternId: patternId,
        productSelection: productSelection,
        projectUrl: projectUrl
    };
}
